import InFilter from '../../../common/support/utils/druid/filters/InFilter';

export const SPLIT_SKAN_MESSAGE = 'Toggle to view the split de-duplicated event counts from both SKAN and Non-SKAN sources.';

export const GROUP_BY_QUERY_TYPE: string = 'groupby';

export const TRUEVIEW_ANALYTICS_REQUIRED_FILTER = new InFilter('last_attributed_touch_data_tilde_feature', [
  'paid advertising',
]);

export const TRUEVIEW_ANALYTICS_DEFAULT_FILTER_DIMENSIONS: string[] = [
  'last_attributed_touch_data_tilde_advertising_partner_name',
  'last_attributed_touch_data_tilde_campaign',
  'user_data_platform',
];

export const TRUEVIEW_ANALYTICS_FILTER_DIMENSIONS: string[] = [
  ...TRUEVIEW_ANALYTICS_DEFAULT_FILTER_DIMENSIONS,
  'attributed',
  'last_attributed_touch_data_tilde_campaign_id',
  'last_attributed_touch_data_dollar_3p',
];

export const TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS = {
  INSTALLS: 'eo_install',
  REINSTALLS: 'eo_reinstall',
  OPENS: 'eo_open',

  REVENUE: 'revenue',

  COMMERCE_PURCHASES: 'PURCHASE',
  COMMERCE_ADDS_TO_CART: 'ADD_TO_CART',
  COMMERCE_ADDS_TO_WISHLIST: 'ADD_TO_WISHLIST',
  COMMERCE_CART_VIEWS: 'VIEW_CART',
  COMMERCE_PURCHASE_INITS: 'INITIATE_PURCHASE',
  COMMERCE_PAYMENT_INFO_ADDS: 'ADD_PAYMENT_INFO',
  COMMERCE_CREDITS_SPENT: 'SPEND_CREDITS',
  COMMERCE_RESERVES: 'RESERVE',
  COMMERCE_AD_CLICKS: 'CLICK_AD',
  COMMERCE_AD_VIEWS: 'VIEW_AD',

  CONTENT_SEARCH: 'SEARCH',
  CONTENT_ITEM_VIEWS: 'VIEW_ITEM',
  CONTENT_ITEMS_VIEWS: 'VIEW_ITEMS',
  CONTENT_RATES: 'RATE',
  CONTENT_SHARES: 'SHARE',
  CONTENT_STREAM_INITS: 'INITIATE_STREAM',
  CONTENT_STREAM_COMPLETIONS: 'COMPLETE_STREAM',

  USER_LIFECYCLE_REGISTER_COMPLETIONS: 'COMPLETE_REGISTRATION',
  USER_LIFECYCLE_TUTORIAL_COMPLETIONS: 'COMPLETE_TUTORIAL',
  USER_LIFECYCLE_LEVEL_ACHIEVES: 'ACHIEVE_LEVEL',
  USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS: 'UNLOCK_ACHIEVEMENT',
  USER_LIFECYCLE_INVITES: 'INVITE',
  USER_LIFECYCLE_LOGINS: 'LOGIN',
  USER_LIFECYCLE_SUBSCRIPTIONS: 'SUBSCRIBE',
  USER_LIFECYCLE_TRIAL_STARTS: 'START_TRIAL',
  USER_LIFECYCLE_OPT_INS: 'OPT_IN',
  USER_LIFECYCLE_OPT_OUTS: 'OPT_OUT',
};

export const TRUEVIEW_ANALYTICS_SKAN_COLUMNS = {
  INSTALLS: 'skan__install',
  REINSTALLS: 'skan__reinstall',
  OPENS: 'skan__open',

  REVENUE: 'skan__revenue',

  COMMERCE_PURCHASES: 'skan__commerce_purchase',
  COMMERCE_ADDS_TO_CART: 'skan__commerce_add_to_cart',
  COMMERCE_ADDS_TO_WISHLIST: 'skan__commerce_add_to_wishlist',
  COMMERCE_CART_VIEWS: 'skan__commerce_view_cart',
  COMMERCE_PURCHASE_INITS: 'skan__commerce_initiate_purchase',
  COMMERCE_PAYMENT_INFO_ADDS: 'skan__commerce_add_payment_info',
  COMMERCE_CREDITS_SPENT: 'skan__commerce_spend_credits',
  COMMERCE_RESERVES: 'skan__commerce_reserve',
  COMMERCE_AD_CLICKS: 'skan__commerce_click_ad',
  COMMERCE_AD_VIEWS: 'skan__commerce_view_ad',

  CONTENT_SEARCH: 'skan__content_search',
  CONTENT_ITEM_VIEWS: 'skan__content_view_item',
  CONTENT_ITEMS_VIEWS: 'skan__content_view_items',
  CONTENT_RATES: 'skan__content_rate',
  CONTENT_SHARES: 'skan__content_share',
  CONTENT_STREAM_INITS: 'skan__content_initiate_stream',
  CONTENT_STREAM_COMPLETIONS: 'skan__content_complete_stream',

  USER_LIFECYCLE_REGISTER_COMPLETIONS: 'skan__user_life_cycle_complete_registration',
  USER_LIFECYCLE_TUTORIAL_COMPLETIONS: 'skan__user_life_cycle_complete_tutorial',
  USER_LIFECYCLE_LEVEL_ACHIEVES: 'skan__user_life_cycle_achieve_level',
  USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS: 'skan__user_life_cycle_unlock_achievement',
  USER_LIFECYCLE_INVITES: 'skan__user_life_cycle_invite',
  USER_LIFECYCLE_LOGINS: 'skan__user_life_cycle_login',
  USER_LIFECYCLE_SUBSCRIPTIONS: 'skan__user_life_cycle_subscribe',
  USER_LIFECYCLE_TRIAL_STARTS: 'skan__user_life_cycle_start_trial',
  USER_LIFECYCLE_OPT_INS: 'skan__user_life_cycle_opt_in',
  USER_LIFECYCLE_OPT_OUTS: 'skan__user_life_cycle_opt_out',
};

export const TRUEVIEW_ANALYTICS_TOTALS_COLUMNS = {
  INSTALLS: 'unified_total__install',
  REINSTALLS: 'unified_total__reinstall',
  OPENS: 'unified_total__open',

  REVENUE: 'unified_total__revenue',

  COMMERCE_PURCHASES: 'unified_total__purchase',
  COMMERCE_ADDS_TO_CART: 'unified_total__add_to_cart',
  COMMERCE_ADDS_TO_WISHLIST: 'unified_total__add_to_wishlist',
  COMMERCE_CART_VIEWS: 'unified_total__view_cart',
  COMMERCE_PURCHASE_INITS: 'unified_total__initiate_purchase',
  COMMERCE_PAYMENT_INFO_ADDS: 'unified_total__add_payment_info',
  COMMERCE_CREDITS_SPENT: 'unified_total__spend_credits',
  COMMERCE_RESERVES: 'unified_total__reserve',
  COMMERCE_AD_CLICKS: 'unified_total__click_ad',
  COMMERCE_AD_VIEWS: 'unified_total__view_ad',

  CONTENT_SEARCH: 'unified_total__search',
  CONTENT_ITEM_VIEWS: 'unified_total__view_item',
  CONTENT_ITEMS_VIEWS: 'unified_total__view_items',
  CONTENT_RATES: 'unified_total__rate',
  CONTENT_SHARES: 'unified_total__share',
  CONTENT_STREAM_INITS: 'unified_total__initiate_stream',
  CONTENT_STREAM_COMPLETIONS: 'unified_total__complete_stream',

  USER_LIFECYCLE_REGISTER_COMPLETIONS: 'unified_total__complete_registration',
  USER_LIFECYCLE_TUTORIAL_COMPLETIONS: 'unified_total__complete_tutorial',
  USER_LIFECYCLE_LEVEL_ACHIEVES: 'unified_total__achieve_level',
  USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS: 'unified_total__unlock_achievement',
  USER_LIFECYCLE_INVITES: 'unified_total__invite',
  USER_LIFECYCLE_LOGINS: 'unified_total__login',
  USER_LIFECYCLE_SUBSCRIPTIONS: 'unified_total__subscribe',
  USER_LIFECYCLE_TRIAL_STARTS: 'unified_total__start_trial',
  USER_LIFECYCLE_OPT_INS: 'unified_total__opt_in',
  USER_LIFECYCLE_OPT_OUTS: 'unified_total__opt_out',
};

export const TRUEVIEW_ANALYTICS_CALCULATION_COLUMNS = {
  CLICK_TO_TOTAL_INSTALL: 'skan__click_to_total_install',
  CLICK_TO_TOTAL_PURCHASE: 'skan__click_to_total_purchase',
  TOTAL_INSTALL_TO_COST: 'skan__total_install_to_cost',
  TOTAL_PURCHASE_TO_COST: 'skan__total_purchase_to_cost',
};

export const TRUEVIEW_ANALYTICS_COLUMN_NAMES = {
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.INSTALLS]: 'Non SKAN install',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.REINSTALLS]: 'Non SKAN reinstall',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.OPENS]: 'Non SKAN open',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.REVENUE]: 'Non SKAN revenue',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PURCHASES]: 'Non SKAN purchase',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_ADDS_TO_CART]: 'Non SKAN add_to_cart',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_ADDS_TO_WISHLIST]: 'Non SKAN add_to_wishlist',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_CART_VIEWS]: 'Non SKAN view_cart',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PURCHASE_INITS]: 'Non SKAN initiate_purchase',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS]: 'Non SKAN add_payment_info',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_CREDITS_SPENT]: 'Non SKAN spend_credits',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_RESERVES]: 'Non SKAN reserve',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_AD_CLICKS]: 'Non SKAN click_ad',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_AD_VIEWS]: 'Non SKAN view_ad',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_SEARCH]: 'Non SKAN search',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_ITEM_VIEWS]: 'Non SKAN view_item',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_ITEMS_VIEWS]: 'Non SKAN view_items',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_RATES]: 'Non SKAN rate',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_SHARES]: 'Non SKAN share',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_STREAM_INITS]: 'Non SKAN initiate_stream',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_STREAM_COMPLETIONS]: 'Non SKAN complete_stream',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS]: 'Non SKAN complete_registration',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS]: 'Non SKAN complete_tutorial',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES]: 'Non SKAN achieve_level',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]: 'Non SKAN unlock_achievement',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_INVITES]: 'Non SKAN invite',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_LOGINS]: 'Non SKAN login',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS]: 'Non SKAN subscribe',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS]: 'Non SKAN start_trial',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_OPT_INS]: 'Non SKAN opt_in',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_OPT_OUTS]: 'Non SKAN opt_out',

  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.INSTALLS]: 'SKAN install',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.REINSTALLS]: 'SKAN reinstall',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.OPENS]: 'SKAN open',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.REVENUE]: 'SKAN revenue',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_PURCHASES]: 'SKAN purchase',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_ADDS_TO_CART]: 'SKAN add_to_cart',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_ADDS_TO_WISHLIST]: 'SKAN add_to_wishlist',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_CART_VIEWS]: 'SKAN view_cart',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_PURCHASE_INITS]: 'SKAN initiate_purchase',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS]: 'SKAN add_payment_info',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_CREDITS_SPENT]: 'SKAN spend_credits',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_RESERVES]: 'SKAN reserve',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_AD_CLICKS]: 'SKAN click_ad',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_AD_VIEWS]: 'SKAN view_ad',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_SEARCH]: 'SKAN search',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_ITEM_VIEWS]: 'SKAN view_item',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_ITEMS_VIEWS]: 'SKAN view_items',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_RATES]: 'SKAN rate',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_SHARES]: 'SKAN share',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_STREAM_INITS]: 'SKAN initiate_stream',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_STREAM_COMPLETIONS]: 'SKAN complete_stream',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS]: 'SKAN complete_registration',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS]: 'SKAN complete_tutorial',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES]: 'SKAN achieve_level',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]: 'SKAN unlock_achievement',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_INVITES]: 'SKAN invite',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_LOGINS]: 'SKAN login',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS]: 'SKAN subscribe',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS]: 'SKAN start_trial',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_OPT_INS]: 'SKAN opt_in',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_OPT_OUTS]: 'SKAN opt_out',

  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.INSTALLS]: 'Unified installs',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.REINSTALLS]: 'Unified reinstalls',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.OPENS]: 'Unified opens',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.REVENUE]: 'Unified revenue',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PURCHASES]: 'Unified purchases',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_ADDS_TO_CART]: 'Unified add_to_cart',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_ADDS_TO_WISHLIST]: 'Unified add_to_wishlist',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_CART_VIEWS]: 'Unified view_cart',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PURCHASE_INITS]: 'Unified initiate_purchase',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS]: 'Unified add_payment_info',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_CREDITS_SPENT]: 'Unified spend_credits',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_RESERVES]: 'Unified reserve',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_AD_CLICKS]: 'Unified click_ad',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_AD_VIEWS]: 'Unified view_ad',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_SEARCH]: 'Unified search',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_ITEM_VIEWS]: 'Unified view_item',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_ITEMS_VIEWS]: 'Unified view_items',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_RATES]: 'Unified rate',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_SHARES]: 'Unified share',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_STREAM_INITS]: 'Unified initiate_stream',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_STREAM_COMPLETIONS]: 'Unified complete_stream',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS]: 'Unified complete_registration',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS]: 'Unified complete_tutorial',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES]: 'Unified achieve_level',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]: 'Unified unlock_achievement',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_INVITES]: 'Unified invite',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_LOGINS]: 'Unified login',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS]: 'Unified subscribe',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS]: 'Unified start_trial',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_OPT_INS]: 'Unified opt_in',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_OPT_OUTS]: 'Unified opt_out',

  [TRUEVIEW_ANALYTICS_CALCULATION_COLUMNS.CLICK_TO_TOTAL_INSTALL]: 'Click to install rate',
  [TRUEVIEW_ANALYTICS_CALCULATION_COLUMNS.CLICK_TO_TOTAL_PURCHASE]: 'Click to purchase rate',
  [TRUEVIEW_ANALYTICS_CALCULATION_COLUMNS.TOTAL_INSTALL_TO_COST]: 'eCPI',
  [TRUEVIEW_ANALYTICS_CALCULATION_COLUMNS.TOTAL_PURCHASE_TO_COST]: 'eCPP',
};

export const TRUEVIEW_ANALYTICS_COLUMN_TOOLTIPS = {
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.INSTALLS]: 'De-duplicated installs from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.REINSTALLS]: 'De-duplicated reinstalls from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.OPENS]: 'De-duplicated opens from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.REVENUE]: 'De-duplicated revenue from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PURCHASES]: 'De-duplicated purchases from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_ADDS_TO_CART]: 'De-duplicated adds to cart from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_ADDS_TO_WISHLIST]: 'De-duplicated adds to wishlist from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_CART_VIEWS]: 'De-duplicated cart views from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PURCHASE_INITS]: 'De-duplicated purchase initiations from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS]: 'De-duplicated payment info adds from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_CREDITS_SPENT]: 'De-duplicated credit spends from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_RESERVES]: 'De-duplicated reserves from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_AD_CLICKS]: 'De-duplicated ad clicks from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_AD_VIEWS]: 'De-duplicated ad views from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_SEARCH]: 'De-duplicated searches from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_ITEM_VIEWS]: 'De-duplicated item views from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_ITEMS_VIEWS]: 'De-duplicated items views from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_RATES]: 'De-duplicated rates from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_SHARES]: 'De-duplicated shares from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_STREAM_INITS]: 'De-duplicated stream initiations from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_STREAM_COMPLETIONS]: 'De-duplicated stream completions from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS]: 'De-duplicated registration completions from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS]: 'De-duplicated tutorial completions from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES]: 'De-duplicated level achieves from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]: 'De-duplicated achievement unlocks from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_INVITES]: 'De-duplicated invites from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_LOGINS]: 'De-duplicated logins from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS]: 'De-duplicated subscriptions from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS]: 'De-duplicated trial starts from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_OPT_INS]: 'De-duplicated opt ins from Device ID based Attribution',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_OPT_OUTS]: 'De-duplicated opt outs from Device ID based Attribution',

  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.INSTALLS]: 'De-duplicated SKAN Attributed installs',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.REINSTALLS]: 'De-duplicated SKAN Attributed reinstalls',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.OPENS]: 'De-duplicated SKAN Attributed opens',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.REVENUE]: 'De-duplicated SKAN Attributed revenue',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_PURCHASES]: 'De-duplicated SKAN Attributed purchases',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_ADDS_TO_CART]: 'De-duplicated SKAN Attributed adds to cart',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_ADDS_TO_WISHLIST]: 'De-duplicated SKAN Attributed adds to wishlist',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_CART_VIEWS]: 'De-duplicated SKAN Attributed cart views',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_PURCHASE_INITS]: 'De-duplicated SKAN Attributed purchase initiations',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS]: 'De-duplicated SKAN Attributed payment info adds',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_CREDITS_SPENT]: 'De-duplicated SKAN Attributed credit spends',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_RESERVES]: 'De-duplicated SKAN Attributed reserves',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_AD_CLICKS]: 'De-duplicated SKAN Attributed ad clicks',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_AD_VIEWS]: 'De-duplicated SKAN Attributed ad views',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_SEARCH]: 'De-duplicated SKAN Attributed searches',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_ITEM_VIEWS]: 'De-duplicated SKAN Attributed item views',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_ITEMS_VIEWS]: 'De-duplicated SKAN Attributed items views',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_RATES]: 'De-duplicated SKAN Attributed rates',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_SHARES]: 'De-duplicated SKAN Attributed shares',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_STREAM_INITS]: 'De-duplicated SKAN Attributed stream initiations',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_STREAM_COMPLETIONS]: 'De-duplicated SKAN Attributed stream completions',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS]: 'De-duplicated SKAN Attributed register completions',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS]: 'De-duplicated SKAN Attributed tutorial completions',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES]: 'De-duplicated SKAN Attributed level achieves',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]: 'De-duplicated SKAN Attributed achievement unlocks',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_INVITES]: 'De-duplicated SKAN Attributed invites',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_LOGINS]: 'De-duplicated SKAN Attributed logins',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS]: 'De-duplicated SKAN Attributed subscriptions',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS]: 'De-duplicated SKAN Attributed trial starts',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_OPT_INS]: 'De-duplicated SKAN Attributed opt ins',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_OPT_OUTS]: 'De-duplicated SKAN Attributed opt outs',

  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.INSTALLS]: 'Unified Total installs from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.REINSTALLS]: 'Unified Total reinstalls from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.OPENS]: 'Unified Total opens from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.REVENUE]: 'Unified Total revenue from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PURCHASES]: 'Unified Total purchases from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_ADDS_TO_CART]: 'Unified Total adds to cart from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_ADDS_TO_WISHLIST]: 'Unified Total adds to wishlist from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_CART_VIEWS]: 'Unified Total cart views from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PURCHASE_INITS]: 'Unified Total purchase initations from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS]: 'Unified Total payment info adds from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_CREDITS_SPENT]: 'Unified Total credit spends from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_RESERVES]: 'Unified Total reserves from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_AD_CLICKS]: 'Unified Total ad clicks from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_AD_VIEWS]: 'Unified Total ad views from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_SEARCH]: 'Unified Total searches from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_ITEM_VIEWS]: 'Unified Total item views from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_ITEMS_VIEWS]: 'Unified Total items views from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_RATES]: 'Unified Total rates from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_SHARES]: 'Unified Total shares from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_STREAM_INITS]: 'Unified Total stream initations from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_STREAM_COMPLETIONS]: 'Unified Total stream completions from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS]: 'Unified Total register completions from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS]: 'Unified Total tutorial completions from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES]: 'Unified Total level achieves from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]: 'Unified Total achievement unlocks from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_INVITES]: 'Unified Total invites from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_LOGINS]: 'Unified Total logins from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS]: 'Unified Total subscriptions from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS]: 'Unified Total trial starts from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_OPT_INS]: 'Unified Total opt ins from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_OPT_OUTS]: 'Unified Total opt outs from both SKAN and Non-SKAN sources',

  [TRUEVIEW_ANALYTICS_CALCULATION_COLUMNS.TOTAL_INSTALL_TO_COST]: 'Effective Cost Per Install: cost divided by number of installs',
  [TRUEVIEW_ANALYTICS_CALCULATION_COLUMNS.TOTAL_PURCHASE_TO_COST]: 'Effective Cost Per Purchase: cost divided by number of purchases',
};

export const TRUEVIEW_ANALYTICS_GROUPS = {
  TRUEVIEW_GROUP_INSTALLS: 'trueview_install_group',
  TRUEVIEW_GROUP_REINSTALLS: 'trueview_reinstall_group',
  TRUEVIEW_GROUP_OPENS: 'trueview_open_group',
  TRUEVIEW_GROUP_REVENUE: 'trueview_revenue_group',
  TRUEVIEW_GROUP_COMMERCE_PURCHASES: 'trueview_commerce_purchases_group',
  TRUEVIEW_GROUP_COMMERCE_ADDS_TO_CART: 'trueview_commerce_add_to_cart_group',
  TRUEVIEW_GROUP_COMMERCE_ADDS_TO_WISHLIST: 'trueview_commerce_add_to_wishlist_group',
  TRUEVIEW_GROUP_COMMERCE_CART_VIEWS: 'trueview_commerce_view_cart_group',
  TRUEVIEW_GROUP_COMMERCE_PURCHASE_INITS: 'trueview_commerce_initiate_purchase_group',
  TRUEVIEW_GROUP_COMMERCE_PAYMENT_INFO_ADDS: 'trueview_commerce_add_payment_info_group',
  TRUEVIEW_GROUP_COMMERCE_CREDITS_SPENT: 'trueview_commerce_spend_credits_group',
  TRUEVIEW_GROUP_COMMERCE_RESERVES: 'trueview_commerce_reserve_group',
  TRUEVIEW_GROUP_COMMERCE_AD_CLICKS: 'trueview_commerce_click_ad_group',
  TRUEVIEW_GROUP_COMMERCE_AD_VIEWS: 'trueview_commerce_view_ad_group',
  TRUEVIEW_GROUP_CONTENT_SEARCH: 'trueview_content_search_group',
  TRUEVIEW_GROUP_CONTENT_ITEM_VIEWS: 'trueview_content_view_item_group',
  TRUEVIEW_GROUP_CONTENT_ITEMS_VIEWS: 'trueview_content_view_items_group',
  TRUEVIEW_GROUP_CONTENT_RATES: 'trueview_content_rate_group',
  TRUEVIEW_GROUP_CONTENT_SHARES: 'trueview_content_share_group',
  TRUEVIEW_GROUP_CONTENT_STREAM_INITS: 'trueview_content_initiate_stream_group',
  TRUEVIEW_GROUP_CONTENT_STREAM_COMPLETIONS: 'trueview_content_complete_stream_group',
  TRUEVIEW_GROUP_USER_LIFECYCLE_REGISTER_COMPLETIONS: 'trueview_lifecycle_complete_registration_group',
  TRUEVIEW_GROUP_USER_LIFECYCLE_TUTORIAL_COMPLETIONS: 'trueview_lifecycle_complete_tutorial_group',
  TRUEVIEW_GROUP_USER_LIFECYCLE_LEVEL_ACHIEVES: 'trueview_lifecycle_achieve_level_group',
  TRUEVIEW_GROUP_USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS: 'trueview_lifecycle_unlock_achievement_group',
  TRUEVIEW_GROUP_USER_LIFECYCLE_INVITES: 'trueview_lifecycle_invite_group',
  TRUEVIEW_GROUP_USER_LIFECYCLE_LOGINS: 'trueview_lifecycle_login_group',
  TRUEVIEW_GROUP_USER_LIFECYCLE_SUBSCRIPTIONS: 'trueview_lifecycle_subscribe_group',
  TRUEVIEW_GROUP_USER_LIFECYCLE_TRIAL_STARTS: 'trueview_lifecycle_start_trial_group',
  TRUEVIEW_GROUP_USER_LIFECYCLE_OPT_INS: 'trueview_lifecycle_opt_in_group',
  TRUEVIEW_GROUP_USER_LIFECYCLE_OPT_OUTS: 'trueview_lifecycle_opt_out_group',
};

export const TRUEVIEW_ANALYTICS_GROUP_NAMES = {
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_INSTALLS]: 'install',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_REINSTALLS]: 'reinstall',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_OPENS]: 'open',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_REVENUE]: 'revenue',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_COMMERCE_PURCHASES]: 'PURCHASE',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_COMMERCE_ADDS_TO_CART]: 'ADD_TO_CART',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_COMMERCE_ADDS_TO_WISHLIST]: 'ADD_TO_WISHLIST',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_COMMERCE_CART_VIEWS]: 'VIEW_CART',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_COMMERCE_PURCHASE_INITS]: 'INITIATE_PURCHASE',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_COMMERCE_PAYMENT_INFO_ADDS]: 'ADD_PAYMENT_INFO',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_COMMERCE_CREDITS_SPENT]: 'SPEND_CREDITS',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_COMMERCE_RESERVES]: 'RESERVE',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_COMMERCE_AD_CLICKS]: 'CLICK_AD',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_COMMERCE_AD_VIEWS]: 'VIEW_AD',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_CONTENT_SEARCH]: 'SEARCH',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_CONTENT_ITEM_VIEWS]: 'VIEW_ITEM',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_CONTENT_ITEMS_VIEWS]: 'VIEW_ITEMS',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_CONTENT_RATES]: 'RATE',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_CONTENT_SHARES]: 'SHARE',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_CONTENT_STREAM_INITS]: 'INITIATE_STREAM',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_CONTENT_STREAM_COMPLETIONS]: 'COMPLETE_STREAM',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_USER_LIFECYCLE_REGISTER_COMPLETIONS]: 'COMPLETE_REGISTRATION',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_USER_LIFECYCLE_TUTORIAL_COMPLETIONS]: 'COMPLETE_TUTORIAL',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_USER_LIFECYCLE_LEVEL_ACHIEVES]: 'ACHIEVE_LEVEL',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]: 'UNLOCK_ACHIEVEMENT',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_USER_LIFECYCLE_INVITES]: 'INVITE',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_USER_LIFECYCLE_LOGINS]: 'LOGIN',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_USER_LIFECYCLE_SUBSCRIPTIONS]: 'SUBSCRIBE',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_USER_LIFECYCLE_TRIAL_STARTS]: 'START_TRIAL',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_USER_LIFECYCLE_OPT_INS]: 'OPT_IN',
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_USER_LIFECYCLE_OPT_OUTS]: 'OPT_OUT',
};

export const TRUEVIEW_ANALYTICS_GROUP_COLUMN_NAMES = {
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.INSTALLS]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.REINSTALLS]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.OPENS]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.REVENUE]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PURCHASES]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_ADDS_TO_CART]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_ADDS_TO_WISHLIST]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_CART_VIEWS]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PURCHASE_INITS]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_CREDITS_SPENT]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_RESERVES]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_AD_CLICKS]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_AD_VIEWS]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_SEARCH]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_ITEM_VIEWS]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_ITEMS_VIEWS]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_RATES]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_SHARES]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_STREAM_INITS]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_STREAM_COMPLETIONS]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_INVITES]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_LOGINS]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_OPT_INS]: 'Non SKAN',
  [TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_OPT_OUTS]: 'Non SKAN',

  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.INSTALLS]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.REINSTALLS]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.OPENS]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.REVENUE]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_PURCHASES]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_ADDS_TO_CART]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_ADDS_TO_WISHLIST]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_CART_VIEWS]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_PURCHASE_INITS]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_CREDITS_SPENT]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_RESERVES]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_AD_CLICKS]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_AD_VIEWS]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_SEARCH]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_ITEM_VIEWS]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_ITEMS_VIEWS]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_RATES]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_SHARES]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_STREAM_INITS]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_STREAM_COMPLETIONS]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_INVITES]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_LOGINS]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_OPT_INS]: 'SKAN',
  [TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_OPT_OUTS]: 'SKAN',

  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.INSTALLS]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.REINSTALLS]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.OPENS]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.REVENUE]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PURCHASES]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_ADDS_TO_CART]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_ADDS_TO_WISHLIST]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_CART_VIEWS]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PURCHASE_INITS]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_CREDITS_SPENT]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_RESERVES]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_AD_CLICKS]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_AD_VIEWS]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_SEARCH]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_ITEM_VIEWS]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_ITEMS_VIEWS]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_RATES]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_SHARES]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_STREAM_INITS]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_STREAM_COMPLETIONS]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_INVITES]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_LOGINS]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_OPT_INS]: 'Total',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_OPT_OUTS]: 'Total',
};

export const TRUEVIEW_ANALYTICS_GROUP_COLUMN_TOOLTIPS = {
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.INSTALLS]: 'Sum of Deduplicated installs from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.REINSTALLS]: 'Sum of Deduplicated reinstalls from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.OPENS]: 'Sum of Deduplicated opens from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.REVENUE]: 'Sum of Deduplicated revenue from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PURCHASES]: 'Sum of Deduplicated purchases from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_ADDS_TO_CART]: 'Sum of Deduplicated adds to cart from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_ADDS_TO_WISHLIST]: 'Sum of Deduplicated adds to wishlist from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_CART_VIEWS]: 'Sum of Deduplicated cart views from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PURCHASE_INITS]: 'Sum of Deduplicated purchase initiations from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS]: 'Sum of Deduplicated payment info adds from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_CREDITS_SPENT]: 'Sum of Deduplicated credit spends from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_RESERVES]: 'Sum of Deduplicated reserves from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_AD_CLICKS]: 'Sum of Deduplicated ad clicks from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_AD_VIEWS]: 'Sum of Deduplicated ad views from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_SEARCH]: 'Sum of Deduplicated searches from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_ITEM_VIEWS]: 'Sum of Deduplicated item views from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_ITEMS_VIEWS]: 'Sum of Deduplicated items views from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_RATES]: 'Sum of Deduplicated rates from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_SHARES]: 'Sum of Deduplicated shares from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_STREAM_INITS]: 'Sum of Deduplicated stream initiations from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_STREAM_COMPLETIONS]: 'Sum of Deduplicated stream completions from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS]: 'Sum of Deduplicated register completions from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS]: 'Sum of Deduplicated tutorial completions from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES]: 'Sum of Deduplicated level achieves from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]: 'Sum of Deduplicated achievement unlocks from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_INVITES]: 'Sum of Deduplicated invites from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_LOGINS]: 'Sum of Deduplicated logins from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS]: 'Sum of Deduplicated subscriptions from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS]: 'Sum of Deduplicated trial starts from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_OPT_INS]: 'Sum of Deduplicated opt ins from both SKAN and Non-SKAN sources',
  [TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_OPT_OUTS]: 'Sum of Deduplicated opt outs from both SKAN and Non-SKAN sources',
};

export const TRUEVIEW_ANALYTICS_GROUP_COLUMNS = {
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_INSTALLS]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.INSTALLS,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.INSTALLS,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.INSTALLS,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_REINSTALLS]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.REINSTALLS,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.REINSTALLS,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.REINSTALLS,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_OPENS]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.OPENS,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.OPENS,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.OPENS,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_REVENUE]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.REVENUE,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.REVENUE,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.REVENUE,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_COMMERCE_PURCHASES]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PURCHASES,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_PURCHASES,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PURCHASES,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_COMMERCE_ADDS_TO_CART]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_ADDS_TO_CART,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_ADDS_TO_CART,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_ADDS_TO_CART,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_COMMERCE_ADDS_TO_WISHLIST]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_ADDS_TO_WISHLIST,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_ADDS_TO_WISHLIST,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_ADDS_TO_WISHLIST,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_COMMERCE_CART_VIEWS]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_CART_VIEWS,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_CART_VIEWS,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_CART_VIEWS,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_COMMERCE_PURCHASE_INITS]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PURCHASE_INITS,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_PURCHASE_INITS,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PURCHASE_INITS,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_COMMERCE_PAYMENT_INFO_ADDS]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_PAYMENT_INFO_ADDS,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_COMMERCE_CREDITS_SPENT]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_CREDITS_SPENT,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_CREDITS_SPENT,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_CREDITS_SPENT,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_COMMERCE_RESERVES]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_RESERVES,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_RESERVES,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_RESERVES,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_COMMERCE_AD_CLICKS]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_AD_CLICKS,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_AD_CLICKS,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_AD_CLICKS,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_COMMERCE_AD_VIEWS]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.COMMERCE_AD_VIEWS,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.COMMERCE_AD_VIEWS,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.COMMERCE_AD_VIEWS,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_CONTENT_SEARCH]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_SEARCH,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_SEARCH,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_SEARCH,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_CONTENT_ITEM_VIEWS]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_ITEM_VIEWS,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_ITEM_VIEWS,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_ITEM_VIEWS,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_CONTENT_ITEMS_VIEWS]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_ITEMS_VIEWS,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_ITEMS_VIEWS,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_ITEMS_VIEWS,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_CONTENT_RATES]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_RATES,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_RATES,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_RATES,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_CONTENT_SHARES]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_SHARES,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_SHARES,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_SHARES,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_CONTENT_STREAM_INITS]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_STREAM_INITS,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_STREAM_INITS,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_STREAM_INITS,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_CONTENT_STREAM_COMPLETIONS]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.CONTENT_STREAM_COMPLETIONS,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.CONTENT_STREAM_COMPLETIONS,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.CONTENT_STREAM_COMPLETIONS,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_USER_LIFECYCLE_REGISTER_COMPLETIONS]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_REGISTER_COMPLETIONS,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_USER_LIFECYCLE_TUTORIAL_COMPLETIONS]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_TUTORIAL_COMPLETIONS,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_USER_LIFECYCLE_LEVEL_ACHIEVES]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_LEVEL_ACHIEVES,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_ACHIEVEMENT_UNLOCKS,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_USER_LIFECYCLE_INVITES]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_INVITES,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_INVITES,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_INVITES,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_USER_LIFECYCLE_LOGINS]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_LOGINS,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_LOGINS,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_LOGINS,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_USER_LIFECYCLE_SUBSCRIPTIONS]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_SUBSCRIPTIONS,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_USER_LIFECYCLE_TRIAL_STARTS]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_TRIAL_STARTS,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_USER_LIFECYCLE_OPT_INS]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_OPT_INS,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_OPT_INS,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_OPT_INS,
  ],
  [TRUEVIEW_ANALYTICS_GROUPS.TRUEVIEW_GROUP_USER_LIFECYCLE_OPT_OUTS]: [
    TRUEVIEW_ANALYTICS_NONSKAN_COLUMNS.USER_LIFECYCLE_OPT_OUTS,
    TRUEVIEW_ANALYTICS_SKAN_COLUMNS.USER_LIFECYCLE_OPT_OUTS,
    TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.USER_LIFECYCLE_OPT_OUTS,
  ],
};

export const TRUEVIEW_ANALYTICS_DEFAULT_SPLIT_SKAN_DATA_CHECKED = false;

export const TRUEVIEW_ANALYTICS_DEFAULT_ACTIVE_COLUMN = 'eo_click';

export const TRUEVIEW_ANALYTICS_DEFAULT_SELECTED_COLUMNS = [...new Set([
  'cost',
  TRUEVIEW_ANALYTICS_DEFAULT_ACTIVE_COLUMN,
  TRUEVIEW_ANALYTICS_TOTALS_COLUMNS.INSTALLS,
  TRUEVIEW_ANALYTICS_CALCULATION_COLUMNS.CLICK_TO_TOTAL_INSTALL,
  TRUEVIEW_ANALYTICS_CALCULATION_COLUMNS.TOTAL_INSTALL_TO_COST,
])];
